import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Typography, Card, CardContent, CardActionArea } from "@mhome/ui";
import TelegramIcon from "@mui/icons-material/Telegram";
import InfoIcon from "@mui/icons-material/Info";
import ResponsiveCardGrid from "../common/responsive-card-grid";
import { useComponentBackgroundColor } from "../common/adaptive-theme-provider";

const MessagingListView = () => {
  const getComponentBgColor = useComponentBackgroundColor();
  const [messagingApps, setMessagingApps] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    handleLoadMessagingApps();
  }, []);

  const handleLoadMessagingApps = () => {
    setLoading(true);
    const apps = [
      {
        id: "telegram",
        name: "Telegram",
      },
    ];

    setMessagingApps(apps);
    setLoading(false);
  };

  const handleCardClick = (app) => {
    history.push(`/messaging/${app.id}`);
  };

  const getLogo = (appId) => {
    const commonIconStyle = {
      width: "28px",
      height: "28px",
    };

    switch (appId) {
      case "telegram":
        return <TelegramIcon style={commonIconStyle} />;
      default:
        return <TelegramIcon style={commonIconStyle} />;
    }
  };

  return (
    <>
      {loading ? (
        <></>
      ) : (
        <div style={{ height: "100%" }}>
          <div style={{ padding: "16px" }}>
            <ResponsiveCardGrid breakpoints={{ xs: 1, sm: 2, md: 4, lg: 6 }}>
              {messagingApps.map((app) => (
                <Card
                  key={app.id}
                  elevation={0}
                  style={{
                    backgroundColor: getComponentBgColor("hsl(var(--card))"),
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    width: "fit-content",
                    alignSelf: "flex-start",
                  }}
                >
                  <CardActionArea
                    style={{
                      cursor: "pointer",
                      WebkitTapHighlightColor: "transparent",
                      borderRadius: "16px",
                      backgroundColor: getComponentBgColor("hsl(var(--card))"),
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor =
                        getComponentBgColor("hsl(var(--accent))");
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor =
                        getComponentBgColor("hsl(var(--card))");
                    }}
                    onClick={() => handleCardClick(app)}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "12px",
                        padding: "8px 12px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        {getLogo(app.id)}
                      </div>
                      <Typography
                        variant="subtitle1"
                        style={{
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {app.name}
                      </Typography>
                    </div>
                  </CardActionArea>
                </Card>
              ))}
            </ResponsiveCardGrid>

            {/* Info Card */}
            <Card
              style={{
                marginTop: "24px",
                backgroundColor: getComponentBgColor("hsl(var(--card))"),
              }}
            >
              <CardContent style={{ paddingTop: "16px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "16px",
                  }}
                >
                  <InfoIcon
                    style={{
                      color: "hsl(var(--primary))",
                      marginTop: "4px",
                      flexShrink: 0,
                    }}
                  />
                  <div>
                    <Typography
                      variant="h6"
                      style={{ marginBottom: "16px", fontWeight: 500 }}
                    >
                      Chat with mHome Assistant through Messaging Apps
                    </Typography>
                    <Typography
                      variant="body2"
                      className="text-muted-foreground"
                      style={{
                        marginBottom: "8px",
                      }}
                    >
                      <strong>How it works:</strong>
                    </Typography>
                    <ul style={{ paddingLeft: "16px", marginBottom: "16px" }}>
                      <li>
                        <Typography
                          component="span"
                          variant="body2"
                          className="text-muted-foreground"
                        >
                          You will be sending and receiving messages to/from a
                          mHome bot. Need to connect to the bot first. Follow
                          each App&apos;s guide flow.
                        </Typography>
                      </li>
                      <li>
                        <Typography
                          component="span"
                          variant="body2"
                          className="text-muted-foreground"
                        >
                          You can connect your messaging account to multiple
                          spaces. But only one space can be active at a time.
                          You can switch at the settings page.
                        </Typography>
                      </li>
                    </ul>
                    <Typography
                      variant="body2"
                      className="text-muted-foreground"
                      style={{
                        marginBottom: "8px",
                      }}
                    >
                      <strong>Notifications:</strong>
                    </Typography>
                    <ul style={{ paddingLeft: "16px", marginBottom: "16px" }}>
                      <li>
                        <Typography
                          component="span"
                          variant="body2"
                          className="text-muted-foreground"
                        >
                          You can set to have the messaging App to receive
                          notifications from mHome. Check the settings page.
                        </Typography>
                      </li>
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      )}
    </>
  );
};

export default MessagingListView;
